export default __webpack_public_path__ + "view-icon.svg";